document.getElementById("checkout")?.addEventListener("click", function(event) {
    // Get all cart items
    const DEFAULT_INSIDE_MSG = '此商品必须与其他商品一起购买';
    const ZU_DEFAULT_INSIDE_MSG = 'This product must be bought with other items.';
    const activeLanguage = getActiveLanguage();
    const cartItems = document.querySelectorAll(".cart-item");
    const cartItem1 = document.getElementById("CartItem-1");
    const cartItem2 = document.getElementById("CartItem-2");
    const cartItem3 = document.getElementById("CartItem-3");
    const cartItem4 = document.getElementById("CartItem-4");
    let onSideMsg = DEFAULT_INSIDE_MSG;
    switch (activeLanguage) {
      case 'zu':
        onSideMsg = ZU_DEFAULT_INSIDE_MSG; // 
        break;
      case 'en':
      default:
        onSideMsg = DEFAULT_INSIDE_MSG; // Default 
        break;
    }
    
    // Check if CartItem-1 is the only item in the cart
    if (cartItems.length === 1 && cartItem1) {
        const itemTitle = cartItem1.querySelector(".cart-item__name").textContent.trim();
        
        // Check if the title matches "另加主食 Add-on Side"
        if (itemTitle === "另加主食 Add-on Side") {
            // Prevent form submission and show an alert
            event.preventDefault();
            alert(onSideMsg);
        }
    } else if (cartItems.length === 2 && cartItem1 && cartItem2){
        const itemTitle = cartItem1.querySelector(".cart-item__name").textContent.trim() + cartItem2.querySelector(".cart-item__name").textContent.trim();
        
        // Check if the title matches "另加主食 Add-on Side"
        if (itemTitle === "另加主食 Add-on Side另加主食 Add-on Side") {
            // Prevent form submission and show an alert
            event.preventDefault();
            alert(onSideMsg);
        }
    } else if (cartItems.length === 3 && cartItem1 && cartItem2 && cartItem3){
        const itemTitle = cartItem1.querySelector(".cart-item__name").textContent.trim() + cartItem2.querySelector(".cart-item__name").textContent.trim() + cartItem3.querySelector(".cart-item__name").textContent.trim();
        
        // Check if the title matches "另加主食 Add-on Side"
        if (itemTitle === "另加主食 Add-on Side另加主食 Add-on Side另加主食 Add-on Side") {
            // Prevent form submission and show an alert
            event.preventDefault();
            alert(onSideMsg);
        }
    } else if (cartItems.length === 4 && cartItem1 && cartItem2 && cartItem3 && cartItem4){
        const itemTitle = cartItem1.querySelector(".cart-item__name").textContent.trim() + cartItem2.querySelector(".cart-item__name").textContent.trim() + cartItem3.querySelector(".cart-item__name").textContent.trim() + cartItem4.querySelector(".cart-item__name").textContent.trim();
        
        // Check if the title matches "另加主食 Add-on Side"
        if (itemTitle === "另加主食 Add-on Side另加主食 Add-on Side另加主食 Add-on Side另加主食 Add-on Side") {
            // Prevent form submission and show an alert
            event.preventDefault();
            alert(onSideMsg);
        }
    }
});
  function getActiveLanguage() {
    const activeLanguageLink = document.querySelector('.disclosure__link--active');
    return activeLanguageLink ? activeLanguageLink.getAttribute('data-value') : 'en';
  }
